"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textSizeMap = exports.textWeightMap = void 0;
exports.textWeightMap = {
    light: 300,
    regular: 400,
    'semi-bold': 600,
    bold: 700,
    'extra-bold': 800,
};
exports.textSizeMap = {
    title: {
        large: 24,
        medium: 18,
    },
    text: {
        large: 16,
        medium: 13,
        small: 12,
        'extra-small': 10,
        tiny: 6,
    },
};
